module.exports = __webpack_public_path__ + "img/ic-sdc.150795db.svg";